import React from 'react'
import { Text, Drawer } from '@lounge-fe/ui-kit'
import { Form } from '../Form'
import { FilterAndSortProps } from '../types'
import { t } from 'i18next'

export const FilterAndSort: React.FC<FilterAndSortProps> = ({
  title,
  sortOptions,
  filterSections,
}) => {
  return (
    <Drawer>
      {({ onClose }) => (
        <>
          <Drawer.Trigger>
            <button className="typography--body-md underline underline-offset-4 w-fit">
              {t('action.filter_and_sort')}
            </button>
          </Drawer.Trigger>
          <Drawer.Content direction="left" className="max-w-[450px]">
            <Drawer.Header className="sm:px-10 sm:py-8">
              {title && <Text variant="title-five">{title}</Text>}
            </Drawer.Header>
            <Drawer.Body className="py-4 sm:px-10">
              <Form
                name={'filters'}
                sections={filterSections}
                showActions={true}
                onClose={onClose}
                sortOptions={sortOptions}
              />
            </Drawer.Body>
          </Drawer.Content>
        </>
      )}
    </Drawer>
  )
}
